<template>
  <div>
    <!-- {{dataQuantity}} -->
    
    <div class="option_selection" v-if="dataQuantity.gmallProductId">
      <div @click="buyNowFromDetail()" class="add-option">{{$t('buyNow')}}</div>
    </div>
    <div class="option_selection" v-else>
      <div v-if="quantity === 0" @click="increment()" class="add-option">{{$t('buyNow')}} <span>&#xff0b;</span></div>
      <div class="quantity-toggle" v-if="quantity > 0">
        <button @click="decrement()" :class="{'disabled' : isDisabledMinus}">&mdash;</button>
        <input type="text" :value="quantity" readonly />
        <button @click="increment()" :class="{'disabled' : isDisabledPlus}">&#xff0b;</button>
      </div>
    </div>
    <div class="loader" v-if="loading">
        <img src="../assets/images/loader.gif" alt="loader" />
      </div>
    <div class="cntntLoad" v-if="blankLoad">
        <img src="../assets/images/loader.gif" alt="loader" />
      </div>
      <div id="cart-snackbar" :class="{'show': addToCartCountAction}">
      <div class="flx" style="font-size: 1.5em;">
        <p>{{$t('itemAddedTocart')}}</p>
        <p style="color:#f93" @click="goToCart()">{{$t('goToCart')}}</p>
        <!-- <router-link :to="{path:'/cart-check-out'}" tag="p" style="color:#f93">{{$t('goToCart')}}</router-link> -->
      </div>
      </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
  </div>
</template>

<script>
import CustomToaster from "../components/Common/CustomToaster";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import types from "../store/types";
import { mapGetters } from "vuex";
export default {
  name: "Quantity",
  components: {
    CustomToaster
  },
  props: {
    dataQuantity: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      quantity: 0,
      loading: false,
      toasterData: {},
      isToasterData: false,
      isDisabledMinus: false,
      isDisabledPlus: false,
      toasterData: {},
      isToasterData: false,
      blankLoad: false,
      addToCartCountAction: false
    };
  },
  computed: {
    ...mapGetters(["cartSize"])
  },
  watch: {
    dataQuantity() {
      this.details = this.dataQuantity;
      if (
      this.quantity == 0 &&
      this.details.maxOrderableQuantity > this.quantity
    ) {
      this.isDisabledMinus = true;
      this.isDisabledPlus = false;
    }
    if (Number(this.details.maxOrderableQuantity) === this.quantity) {
      this.isDisabledPlus = true;
      this.isDisabledMinus = true;
    }
    }
  },

  methods: {
    buyNowFromDetail(){
      
    },
    goToCart(){
      if(this.$route.query.shopid){
        this.$router.push('/cart-check-out?source=LOCAL_HOME&shopid=' + this.$route.query.shopid )
      }else{
        this.$router.push('/cart-check-out?source=LOCAL_HOME')
      }
      
    },
    increment() {
      if (this.quantity === Number(this.details.maxOrderableQuantity)) {
        this.isDisabledPlus = true;
        this.isDisabledMinus = false;
      }
      
       if (this.quantity === this.details.maxOrderableQuantity) {
          this.isDisabledPlus = true;
        }
         if(this.quantity === 0){
            const cartObj = {
                sellerItemRelationshipId: Number(this.details.sellerItemRelationshipId),
                orderedQuantity: 1
            }
        let orderSource = null;
        if((this.$route.query.typeOfSource && this.$route.query.campaignIdentifier && this.$route.query.campaignUnitIdentifier)|| (this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier && this.$route.query.campaignUnitIdentifier)){
          if(this.$route.query.typeOfSource){
            orderSource = this.$route.query.typeOfSource + '&campaignIdentifier=' +this.$route.query.campaignIdentifier + '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier
          }else if(this.$route.query.source){
            orderSource = this.$route.query.source + '&campaignIdentifier=' +this.$route.query.campaignIdentifier + '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier
          }
        }else if((this.$route.query.typeOfSource && this.$route.query.campaignIdentifier)|| (this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier)){
          if(this.$route.query.typeOfSource){
            orderSource = this.$route.query.typeOfSource + '&campaignIdentifier=' +this.$route.query.campaignIdentifier
          }else if(this.$route.query.source){
            orderSource = this.$route.query.source + '&campaignIdentifier=' +this.$route.query.campaignIdentifier
          }
        }
        else if(!this.$cookie.get('version-code')){
          console.log('bdddsb')
            orderSource = 'STORE_LOGIN'          
        }else{
            if(this.$route.params.mid === '0'){
                orderSource = 'MERCHANDISE_PRODUCT'
            }else if(this.$route.name === 'MerchandiseIdProductListing'){
                orderSource = 'LOCAL91_BANNER'
            }else if(this.$route.query.type === 'MOST_SELLING_PRODUCT'){
                orderSource = 'MOST_SELLING_PRODUCT'
            }else if(this.$route.name === 'home'){
                orderSource = 'LOCAL91_HOME'
            }else if(this.$route.name === 'SearchPage'){
                orderSource = 'LOCAL91_SEARCH'
            }else if(this.$route.name === 'ProductListing'){
              if(this.$route.query.type === 'GMALL_FACTORY_PRODUCTS'){
                orderSource = 'GMALL_FACTORY_PRODUCTS'
              }else{
                orderSource = 'LOCAL91_CATEGORY_BROWSING'
              }
                
            }else{
              orderSource = this.$route.query.source
            }
          
        }
        
        this.blankLoad = true
          ApiCaller(constant.LOCAL_SHOP_URL_CART, "add-to-cart?orderSourceType=" + orderSource  , "post" , cartObj)
          .then(data => {
              ApiCaller(
                  constant.LOCAL_SHOP_URL,
                  'add-user-traking/?orderSourceType=' + orderSource + '&sellerItemRealtionShipId=' + this.details.sellerItemRelationshipId,
                  'post'
                )
                .then((data) => {
                  // this.addToCartCountAction = true
                  this.addToCartCountAction = !this.addToCartCountAction
                    setTimeout(()=> {
                      this.addToCartCountAction = !this.addToCartCountAction;        
                    }, 3000);
                })
                .catch((err) => {
                  console.log(err);
                });
            this.blankLoad = false
            if (this.details.maxOrderableQuantity > this.quantity) {
                this.quantity++;
                this.isDisabledMinus = false;
            }            
            this.$emit('updateCartCount')
          }).catch(err => {
            this.blankLoad = false
              if (err.response.data.errorCodes[0] == "PRODUCT_IS_OUT_OF_STOCK") {
                this.loading = false;
                this.toasterData = {
                  msg: "Item Out of Stock",
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              } else if (err.response.data.errorCodes[0] == "CART_SIZE_EXCEEDED") {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t('cartSizeExceeded',{itemcount: '10'}),
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }
              else if (err.response.data.errorCodes[0] == "ITEM_ALREADY_EXISTS_IN_CART") {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t('itemAlreadyExist'),
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
                if(this.itemAddedValue){
                    this.$router.push('/cart-check-out')
                  }
              }else if (err.response.data.errorCodes[0] == "MAX_ALLOWED_ORDER_LIMIT_REACHED") {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t('orderLimitfull'),
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }
              else if (err.response.data.errorCodes[0] == "SINGLE_SELLER_ITEMS_ALLOWED_IN_CART") {
                this.loading = false;
                this.toasterData = {
                  msg: "एक बार में एक ही दूकान से आर्डर कर सकते हैं।",
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }
              else if (err.response.data.errorCodes[0] == "MORE_QUANTITY_IN_CART") {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t('orderLimitfull'),
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }
              else if (err.response.data.errorCodes[0] == "SHOP_ITEM_NOT_ALLOWED_WITH_MALL91_SUPPLY_ITEM") {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t('canNotAddItemWithOtherShops'),
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }else if (err.response.data.errorCodes[0] == "ONLY_KIRANA_ITEM_ALLOWED_IN_CART") {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t('onlyKiranaItemAllowedInCart'),
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }
              else if (err.response.data.errorCodes[0] == "ONLY_SINGLE_ITEM_ALLOWED_TO_ADD_FOR_COD_PARTIAL_PAYMENT") {
                this.loading = false;
                this.toasterData = {
                  msg: 'You can not add this item with current item in cart. Please complete your order first',
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }
              else if (err.response.data.errorCodes[0] == "MAX_ALLOWED_QUANTITY_LIMIT_FOR_SKU_REACHED" && this.dataQuantity.maxAllowedQuantityPerSku) {
                this.loading = false;
                this.toasterData = {
                  msg: `Can not add or order more than ${this.dataQuantity.maxAllowedQuantityPerSku} quantity of an item in a day`,
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }
              else if (err.response.data.errorCodes[0] == "MAX_ALLOWED_QUANTITY_LIMIT_FOR_ALL_SKU_REACHED" && this.dataQuantity.maxAllowedQuantity) {
                this.loading = false;
                this.toasterData = {
                  msg: `Can not add or order more than ${this.dataQuantity.maxAllowedQuantity} quantity per day`,
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }
               else if (
                err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
                err.response.data.message ==
                  "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
              ) {
                try {
                  _JWT.refereshToken = res => {
                    if (res != "fail") {
                      this.$cookie.set("JWT-TOKEN", res);
                    } else {
                      this.loading = false;
                    }
                  };
                  JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                } catch (err) {
                  this.loading = false;
                  this.$emit('notLoggedInUser')
                  console.log(err);
                }
              } else {
                console.log(err);
                this.toasterData = {
                  msg: err.response.data.message,
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
                this.loading = false;
              }
            });
        }else{
            this.blankLoad = true
          const obj = {
            sellerItemRelationshipId: Number(this.details.sellerItemRelationshipId),
            orderedQuantity: this.quantity + 1
          }
          ApiCaller(constant.LOCAL_SHOP_URL_CART, "update-quantity-cart", "post", obj)
          .then((data) => {
             if (this.details.maxOrderableQuantity > this.quantity) {
                this.quantity++;
                this.isDisabledMinus = false;
            }
            this.addToCartCountAction = !this.addToCartCountAction
                    setTimeout(()=> {
                      this.addToCartCountAction = !this.addToCartCountAction;        
                    }, 3000);
            this.blankLoad = false    
          }).catch(err =>{
              this.blankLoad = false
              if (
                err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
                err.response.data.message ==
                  "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
              ) {
                try {
                  _JWT.refereshToken = res => {
                    if (res != "fail") {
                      this.$cookie.set("JWT-TOKEN", res);
                    } else {
                      this.$emit('notLoggedInUser')
                      this.loading = false;
                    }
                  };
                  JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                  this.$emit('notLoggedInUser')
                } catch (err) {
                  this.loading = false;

                  console.log(err);
                }
              }  else if (err.response.data.errorCodes[0] == "MAX_ALLOWED_QUANTITY_LIMIT_FOR_SKU_REACHED" && this.dataQuantity.maxAllowedQuantityPerSku) {
                this.loading = false;
                this.toasterData = {
                  msg: `Can not add or order more than ${this.dataQuantity.maxAllowedQuantityPerSku} quantity of an item in a day`,
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }
              else if (err.response.data.errorCodes[0] == "MAX_ALLOWED_QUANTITY_LIMIT_FOR_ALL_SKU_REACHED" && this.dataQuantity.maxAllowedQuantity) {
                this.loading = false;
                this.toasterData = {
                  msg: `Can not add or order more than ${this.dataQuantity.maxAllowedQuantity} quantity per day`,
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }else if (err.response.data.errorCodes[0] == "MORE_QUANTITY_IN_CART") {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t('orderLimitfull'),
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
              }else {
                console.log(err);
                this.toasterData = {
                  msg: err.response.data.message,
                  color: "#E51C24",
                  iconName: "close"
                };
                this.isToasterData = true;
                this.loading = false;
              }  
          })
        }
        
       
      
    //   this.$emit("getItemQuantity", this.quantity, this.details.sellerItemRelationshipId);
    },
    decrement() {
      if (this.details.maxOrderableQuantity >= this.quantity) {
        this.isDisabledPlus = false;
      }
       if (this.quantity === 0) {
        this.isDisabledMinus = true;
        this.isDisabledPlus = true;
        return;
      } else {
          
        if(this.quantity > 1){
            this.quantity--;
        const cartObj = {
            sellerItemRelationshipId: Number(this.details.sellerItemRelationshipId),
            orderedQuantity: this.quantity
        }
        let orderSource = null;
        if(this.$route.query.source){
          orderSource = this.$route.query.source
        }else{
          if(this.$route.params.mid === '0'){
                orderSource = 'MERCHANDISE_PRODUCT'
            }else if(this.$route.name === 'MerchandiseIdProductListing'){
                orderSource = 'LOCAL91_BANNER'
            }else if(this.$route.query.type === 'MOST_SELLING_PRODUCT'){
                orderSource = 'MOST_SELLING_PRODUCT'
            }else if(this.$route.name === 'home'){
                orderSource = 'LOCAL91_HOME'
            }else if(this.$route.name === 'SearchPage'){
                orderSource = 'LOCAL91_SEARCH'
            }else if(this.$route.name === 'ProductListing'){
              if(this.$route.query.type === 'GMALL_FACTORY_PRODUCTS'){
                orderSource = 'GMALL_FACTORY_PRODUCTS'
              }else{
                orderSource = 'LOCAL91_CATEGORY_BROWSING'
              }
            }else{
              orderSource = this.$route.query.source
            }
        }
        this.blankLoad = true
          const obj = {
            sellerItemRelationshipId: Number(this.details.sellerItemRelationshipId),
            orderedQuantity: this.quantity
          }
          ApiCaller(constant.LOCAL_SHOP_URL_CART, "update-quantity-cart", "post", obj)
          .then((data) => { 
            this.addToCartCountAction = !this.addToCartCountAction
                    setTimeout(()=> {
                      this.addToCartCountAction = !this.addToCartCountAction;        
                    }, 3000);             
              this.blankLoad = false            
            // console.log(data.data)
            // this.$emit("callBackCartPage", this.quantity, itemID);
          }).catch(err =>{
              this.blankLoad = false  
          })
        }else{
            this.quantity = 0
        }
        // this.$emit("getItemQuantity", this.quantity, this.details.sellerItemRelationshipId);
      }
    }
  },
  mounted() {
    this.details = this.dataQuantity;
    if (
      this.quantity == 0 &&
      this.details.maxOrderableQuantity > this.quantity
    ) {
      this.isDisabledMinus = true;
      this.isDisabledPlus = false;
    }
    if (Number(this.details.maxOrderableQuantity) === this.quantity) {
      this.isDisabledPlus = true;
      this.isDisabledMinus = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.product-added::before{
  content: "";
  position: fixed;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: #f93;
  opacity: 0;
  z-index: 99;
  animation: linear GoTop 1s 1;

}
@keyframes GoTop {
  0%{
    top: calc(100% - 42px);
    right: 36px;
    opacity: 1;
    transform: scale(1.2);
    height: 20px;
    width: 20px;
  }
  90%{
    top: 16px;
    right: 10px;
  }
  100%{
    opacity: 0.8;
    height: 12px;
    width: 12px;
  }
}
.option_selection {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // position: relative;
  .add-option{
      background: #0091FF;
      color: #fff;
      font-weight: 600;
        width: 100%;
        border-radius: 5px;
        text-align: center;
        /* padding-right: 25px; */
        position: relative;
        font-size: 0.875em;
        padding: 4px;
        text-transform: UPPERCASE;
        span{
            position: absolute;
            right: 10px;
            background: #7bbae985;
            border-radius: 50%;
            width: 20px;
            height: 20px;
        }
  }
}
.quantity-toggle {
  display: flex;
  justify-content: center;
  width: 70%;
}
.quantity-toggle button,
.quantity-toggle input {
  border: 1px solid #ddd;
  text-align: center;
  padding: 4px 8px;
    color: #555;
    font-weight: 600;
    font-size: 0.938em;
}
.quantity-toggle button.disabled {
  opacity: 0.3;
  pointer-events: none;
}
</style>
